<template>
  <v-menu
    width="220"
    nudge-right="-70"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        depressed
        class="btn-medium"
        :class="customClass ? customClass : 'mr-4'"
        color="#D9E7FC"
        v-bind="attrs"
        v-on="on"
      >
        Select Column
        <v-icon class="mr-1">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card width="220" class="mx-auto">
      <v-list>
        <v-list-item @click="isSelectedAll = !isSelectedAll">
          <v-list-item-action>
            <v-checkbox v-model="isSelectedAll"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ isSelectedAll ? 'Unselect All' : 'Select All' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item-group v-model="innerValue" multiple>
          <template v-for="(item, i) in headers">
            <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
            <v-list-item v-else :key="`item-${i}`" :value="item">
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    :true-value="item"
                    readonly
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'select-column-filter',
  props: {
    value: {},
    headers: {},
    customClass: {}
  },
  data: () => ({
    innerValue: []
  }),
  computed: {
    isSelectedAll: {
      get() {
        return this.headers
          ? this.innerValue.length === this.headers.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headers.forEach(function(user) {
            selected.push(user);
          });
        }

        this.$emit('input', selected);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.innerValue = val;
      }
    },
    innerValue(val) {
      this.$emit('input', val);
    }
  }
};
</script>
